import { baseAPI } from "../baseApi"

export const objectsApiSlice = baseAPI.injectEndpoints({
    endpoints: builder => ({
        // запрос на получение структуры типов объектов и разделов
        getObjectTypesStructure: builder.query<any, any>({
            query: (args) => ({
                url: `objTypes/get?AuthToken=${args.token}`
            })
        }),
        // запрос на получение структуры типов объектов и разделов
        getAddressTypes: builder.query<any, any>({
            query: () => ({
                url: `address`
            })
        }),
    })
})

export const {
    useLazyGetObjectTypesStructureQuery,
    useLazyGetAddressTypesQuery
} = objectsApiSlice


